import React, { useState, useEffect } from "react";
import axios from "axios";
import { Progress } from "reactstrap";
import Widget from "../../../../components/Widget";

const ServerStatistic = () => {
  const [serverStatisticsData1, setServerStatistics1] = useState("1%/0°C/0.00GHz");
  const [serverStatisticsData2, setServerStatistics2] = useState("22%/33 GB (150) GB");
  const [serverStatisticsData3, setServerStatistics3] = useState("15%/70 Kb/s▲ (150) Kb/s▼");

  const [percent1, setPercent1] = useState(1) 
  const [percent2, setPercent2] = useState(22)
  const [percent3, setPercent3] = useState(15) //last 150 - 500 / 70 -300


  useEffect(() => {
    const interval = setInterval(() => {
      const randomPercent1 = Math.floor(Math.random() * (30 - 10 + 1)) + 10
      setPercent1(randomPercent1)
      setServerStatistics1(`${randomPercent1}%/0°C/0.00GHz`)

      const randomPercent2 = Math.floor(Math.random() * (40 - 20 + 1)) + 20
      setPercent2(randomPercent2)
      let value2= randomPercent2*150/100
      setServerStatistics2(`${randomPercent2}%/${value2} GB (150) GB`)

      const randomPercent3 = Math.floor(Math.random() * (500 - 150 + 1)) + 150;
      const randomInt = Math.floor(Math.random() * (300 - 70 + 1)) + 70;

      let value3= randomPercent2*100/1000

      setServerStatistics3(`${value3}%/${randomInt} Kb/s▲ (${randomPercent3}) Kb/s▼`)
      setPercent3(value3)

    }, 10000);

    return () => clearInterval(interval);
  }, []);

  const getBgColor = (count) => {
    let percentageCount = count;
    if (percentageCount >= 50) {
      if (percentageCount >= 70) {
        return "danger";
      } else {
        return "primary";
      }
    } else {
      return "success";
    }
  };

  return (
    <Widget
      className="widget-sm hotFix"
      title={
        <>
          <div className="Server">
            <img
              src="/icons/statistic.png"
              width={window.innerWidth < 1576 ? "40" : "60"}
            />
            <div className="flexCol">
              <h6 style={{ color: "#f4f4f599" }} className="m-0">
                Server <span className="">Statistic</span>
              </h6>
            </div>
          </div>
        </>
      }
    >
      <div className="">
        <div className="mb-4">
          <div className="clearfix fs-mini">
            <span className="pull-right m-0 fw-semi-bold">{"CPU"}</span>
            <span className="fs-mini">{serverStatisticsData1}</span>
          </div>
          <Progress
            color={getBgColor(percent1)}
            className="bg-widget-transparent-lighter progress-xs"
            value={percent1}
          />
        </div>

        <div className="mb-4">
          <div className="clearfix fs-mini">
            <span className="pull-right m-0 fw-semi-bold">{"MEM"}</span>
            <span className="fs-mini">{serverStatisticsData2}</span>
          </div>
          <Progress
            color={getBgColor(percent2)}
            className="bg-widget-transparent-lighter progress-xs"
            value={percent2}
          />
        </div>

        <div className="mb-4">
          <div className="clearfix fs-mini">
            <span className="pull-right m-0 fw-semi-bold">{"LAN"}</span>
            <span className="fs-mini">{serverStatisticsData3}</span>
          </div>
          <Progress
            color={getBgColor(percent3)}
            className="bg-widget-transparent-lighter progress-xs"
            value={percent3}
          />
        </div>
      </div>
    </Widget>
  );
};

export default ServerStatistic;
